module.exports = __webpack_public_path__ + "img/c-icon.8ce59826.png";